export default __webpack_public_path__ + "static/media/family@4x.f102c5d6.png";